import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { AssetFinanceUrl } from "../../../../../config";
import CoOwnerForm from "./CoOwnerForm";

const base_url = AssetFinanceUrl.uri;

const coOwnerColumns = [
  { field: "Id", headerName: "ID", width: 80 },
  { field: "FullName", headerName: "Full Name", flex: 1 },
  { field: "IdNumber", headerName: "ID / Passport No.", flex: 1 },
  { field: "PhoneNumber", headerName: "Phone", flex: 1 },
  { field: "Email", headerName: "Email", flex: 1 },
  { field: "Relationship", headerName: "Relationship", flex: 1 },
];

const CoOwnerModal = () => {
  const navigate = useNavigate();
  const collateralAssetId = localStorage.getItem("collateralAssetId");
  const ownershiptype = localStorage.getItem("ownershiptype");

  if (!collateralAssetId) return null;

  // Wrapper injects collateralAssetId into the form without needing
  // DynamicTableForJson to pass through custom props.
  const FormWithAsset = (formProps) => (
    <CoOwnerForm {...formProps} collateralAssetId={Number(collateralAssetId)} />
  );

  const actions = {
    entity: "Approved Customer",
    isSubright: true,
    edit: { key: "EDIT", button_name: "Edit", Show_Button: true, permission: "EditPermission" },
    delete: { key: "DELETE", button_name: "Delete", Show_Button: true, permission: "DeletePermission" },
    add: { key: "ADD", button_name: "Add Co-Owner", Show_Button: true, permission: "CreatePermission" },
    dataObject: {
      ignoreFields: ["CreatedBy", "UpdatedBy", "UpdatedAt", "CollateralAssetId"],
      objectName: "collateralCoOwnerByColumnValues",
      parameters: { collateralAssetId: Number(collateralAssetId) },
      inputObjectName: "coOwner",
    },
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button onClick={() => navigate(-1)} variant="contained">
          Back to Assets
        </Button>
      </Box>
      <DynamicTableForJson
        title={`Co-Owner — Asset #${collateralAssetId}`}
        subtitle="Manage the co-owner details for this collateral asset"
        FormComponent={FormWithAsset}
        columns={coOwnerColumns}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default CoOwnerModal;